<template lang="pug">
	section.container-fluid.animated.fadeIn.pt-5

		b-row
			b-col(cols="12" lg="6" xl="4")
				transition(name="fade")
					EventDetail(:event="event.data")

			b-col(cols="12" lg="6" xl="8")
				b-card(no-body)
					b-tabs(v-model="page.event.tabIndex" card)

						b-tab(title='О мероприятии')
							div(v-html='event.data.description') {{ event.data.description }}

						b-tab(title='Докладчики' v-if="speakers.data.length")
							speakers
		programBlock#lectures(v-if="sessions.data.length")

</template>

<script>
	import {mapActions, mapState} from 'vuex'

    // Vue components
	import speakers from './components/speakers'
	// import counter from './components/counter'
	import EventDetail from "./components/EventDetail";
	import sessionsBlock from "./partials/sessions-block";
	import programBlock from "./partials/programBlock";


    export default {
        name: 'Event',
        components: {
			speakers,
			// counter,
			EventDetail,
			sessionsBlock,
			programBlock,
        },
        data: () => ({
        }),
		methods: {
			...mapActions('event/nested/sessions', ['getEventSessions']),
			...mapActions('event/nested/speakers', ['getEventSpeakers']),
		},
        computed: {
			...mapState(['page']),
			...mapState(['event']),
			...mapState({
				speakers: state=>state.event.speakers,
				sessions: state => state.event.sessions,
			}),
        },
		beforeMount() {
			this.$store.dispatch('getEventSessions', { id:this.event.data.id, params: {approved:true} });
			this.$store.dispatch('getEventSpeakers',{ id:this.event.data.id })
		}
	}
</script>
